// extracted by mini-css-extract-plugin
export default {"root":"AdvancedMath_root__G7VNK","header":"AdvancedMath_header__RCwjw"};